import React from "react";
import { t } from "i18next";
import axios from "axios";
import { Upload, Form, Button } from "antd";
import { getURl } from "services/core";
import { Util } from "common/util";

const util = new Util();
const url = `${getURl()}`;

export function UploadFile(props) {
  const [fileList, setFileList] = React.useState([]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const uploadImage = (options) => {
    const { file } = options;
    const logo = props.logoPath;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${util.getAccessToken()}`,
      },
    };

    if (logo) {
      axios({
        url: `${url}/file/v1/file/delete?path=${logo}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${util.getAccessToken()}`,
        },
        method: "Delete",
      });

      formData.append("logo", file);
      try {
        axios
          .post(`${url}/file/v1/setting/logo`, formData, config)
          .then((response) => {
            props.setLogo(`${response.data.key}`);
            if (response.status === 200) {
              util.sweetAlertMessage(t("text_success_update"), "success");
            }
          })
          .catch((err) => {
            util.sweetAlertMessage(err.message, "error");
          });
      } catch (err) {
        util.sweetAlertMessage(err.message, "error");
      }
    } else {
      if (!logo) {
        formData.append("logo", file);
        try {
          axios
            .post(`${url}/file/v1/setting/logo`, formData, config)
            .then((response) => {
              props.setLogo(`${response.data.key}`);
              if (response.status === 200) {
                util.sweetAlertMessage(t("text_success_update"), "success");
              }
            })

            .catch((err) => {
              util.sweetAlertMessage(err.message, "error");
            });
        } catch (err) {
          util.sweetAlertMessage(err.message, "error");
        }
      }
    }
  };

  const onChange = ({ file, fileList, event }) => {
    setFileList(fileList);
  };

  return (
    <Form.Item style={props.style} extra={props.extra}>
      <Upload
        customRequest={uploadImage}
        maxCount={1}
        method="post"
        action={`${url}/file/v1/setting/logo`}
        name={props.name}
        valuePropName="fileList"
        getValueFromEvent={normFile}
        onChange={onChange}
        status={props.status}
        onPressEnter={props.onPressEnter}
        defaultFileList={fileList}
      >
        <Button>{t("text_upload_an_image")}</Button>
      </Upload>
    </Form.Item>
  );
}
